import { PessoaJuridicaSisbi } from "../sisbi/pessoa-juridica-sisbi";

export class SuspensaoInstituicaoSgsia{

    public static readonly SITUACAO_RETIVACAO_NAO_SOLICITADA = 'NAO_SOLICITADA';
    public static readonly SITUACAO_RETIVACAO_SOLICITADA   = 'SOLICITADA';
    public static readonly SITUACAO_RETIVACAO_REPROVADA   = 'REPROVADA';
    public static readonly SITUACAO_RETIVACAO_ACEITA = 'ACEITA';

    public static readonly  SITUACAO_ANALISE_SIM = "SIM";
    public static readonly  SITUACAO_ANALISE_NAO = "NAO";
    public static readonly  SITUACAO_ANALISE_NAO_SE_APLICA = "NAO_SE_APLICA";


	idSuspensao: number;
    idInstituicao: number;
    instituicao: PessoaJuridicaSisbi;
	prazoParaResponder: (undefined | 15 | 30 | 60 | 90);
    suspenso: string;
    dataSuspensao: Date;
    motivo: string;
    dataPedidoReativacao: Date;
    pedidoReativacao: string;
    situacaoReativacao: any;
    dataReativacao: Date;
    analiseReativacao: string;
    justificativaValida: any;
    realizouCorrecoes: any;
    enviouDocumentacao: any;
    arquivosSuspensao: Array<any>;
    arquivosReativacao: Array<any>;


    static fromJson(jsonData: any): SuspensaoInstituicaoSgsia{
        return Object.assign(new SuspensaoInstituicaoSgsia(), jsonData);
    }

    get descricaoSituacaoReativacao():string{
        if (this.situacaoReativacao === SuspensaoInstituicaoSgsia.SITUACAO_RETIVACAO_NAO_SOLICITADA) {
            return 'Não Solicitada';
        }
        if (this.situacaoReativacao === SuspensaoInstituicaoSgsia.SITUACAO_RETIVACAO_SOLICITADA) {
            return 'Solicitada';
        }
        if (this.situacaoReativacao === SuspensaoInstituicaoSgsia.SITUACAO_RETIVACAO_REPROVADA) {
            return 'Reprovada';
        }
        if (this.situacaoReativacao === SuspensaoInstituicaoSgsia.SITUACAO_RETIVACAO_ACEITA) {
            return 'Aceita';
        }
        return this.situacaoReativacao;
    }

    private descSituacaoAnalise(situacao: string):string{
        if (situacao === SuspensaoInstituicaoSgsia.SITUACAO_ANALISE_SIM) {
            return 'Sim';
        }
        if (situacao === SuspensaoInstituicaoSgsia.SITUACAO_ANALISE_NAO) {
            return 'Não';
        }
        if (situacao === SuspensaoInstituicaoSgsia.SITUACAO_ANALISE_NAO_SE_APLICA) {
            return 'Não se aplica';
        }
        return situacao;
    }

}
